import http from './http';

export default {
  createCallRailIntegration(data, validationErrors) {
    return http(validationErrors).post(`/v1/call-rail`, data);
  },
  getCallRailAccountList(market_id, validationErrors) {
    return http(validationErrors).get(`/v1/call-rail/${market_id}/accounts`);
  },
  setCallRailAccount(data, validationErrors) {
    return http(validationErrors).put(`/v1/call-rail/account`, data);
  },
  getCallRailCompanyList(market_id, validationErrors) {
    return http(validationErrors).get(`/v1/call-rail/${market_id}/companies`);
  },
  setCallRailCompany(data, validationErrors) {
    return http(validationErrors).put(`/v1/call-rail/company`, data);
  },
  getCallRailPhoneNumberList(market_id, validationErrors) {
    return http(validationErrors).get(`/v1/call-rail/${market_id}/phone_numbers`);
  },
  getCallRailCallLogsForContacts(market_id, data, validationErrors) {
    return http(validationErrors).put(`/v1/call-rail/${market_id}/call_logs`, data);
  },
  getCallRailTextLogsForContacts(market_id, data, validationErrors) {
    return http(validationErrors).put(`/v1/call-rail/${market_id}/text_logs`, data);
  },
  getRecording(id, validationErrors) {
    return http(validationErrors).get(`/v1/call-rail/recordings/${id}`);
  },
  resync(data, validationErrors) {
    return http(validationErrors).put(`/v1/call-rail/sync_numbers`, data);
  }
}
